<div class="page-headline">
    <div id="{{ module + '-icon' }}" class="icon-area">
        <mat-icon fontSet="fas" fontIcon="{{ moduleIcon }}" inline> </mat-icon>
    </div>
    <div class="headline-text">
        <div class="info-color bread-crumb-text layout-style">
            <a routerLink="/home">
                <span>Home</span>
                <span *ngIf="moduleLink && !linkArray">&nbsp;&gt;&nbsp;</span>
            </a>
            <div *ngIf="moduleLink && !linkArray">
                <a routerLink="/{{ moduleLink }}">{{ linkTitle }} </a>
            </div>
            <div *ngFor="let link of linkArray" class="layout-style">
                <div *ngIf="!moduleLink && linkArray && link.showLink">
                    <span>&nbsp;&gt;&nbsp;</span>
                    <a class="navigation-link-breadcrumb" (click)="onClick(link.moduleLink)"
                        >{{ link.linkTitle }}
                    </a>
                </div>
            </div>
        </div>
        <div class="page-tile-text">
            {{ pageTitle }}
        </div>
    </div>
</div>
